import React, { useState } from 'react';
import { TabsProps } from 'antd';

import OSPatchExportButton from '@totem/components/devices/os-patch-installs/osPatchExportButton';
import OSPatchReportContainer from '@totem/components/osPatchReport/osPatchReportContainer';
import OSPatchReportTable from '@totem/components/osPatchReport/osPatchReportTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const styles = {
  inset: {
    marginLeft: '20px',
    marginRight: '20px',
  },
  totals: {
    fontSize: '16px',
    marginRight: '20px',
  },
  tabContainer: {
    paddingRight: '2rem',
    paddingLeft: '2rem',
  },
};

const OSPatchReportPage = () => {
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const getTabItems = () => {
    const tabItems: TabsProps['items'] = [
      {
        key: 'details',
        label: 'Details',
        children: (
          <>
            <OSPatchReportTable />
          </>
        ),
      },
    ];
    return tabItems;
  };

  return (
    <ContentLayout>
      <OSPatchReportContainer onRecordTotalChanged={setTotalRecords}>
        <IBCard isCovered>
          <IBTabs
            defaultActiveKey="Report"
            tabBarExtraContent={
              <span>
                <RecordCountBadge count={totalRecords} />
                &nbsp;&nbsp;&nbsp;
                <OSPatchExportButton />
              </span>
            }
            style={styles.tabContainer}
            items={getTabItems()}
          />
        </IBCard>
      </OSPatchReportContainer>
    </ContentLayout>
  );
};

export default OSPatchReportPage;
